<template>
  <PageLayout>
    <PageHeader :breadcrumb="[{ title: $t(`Common.title.homeTitle`) }]" />
    <!-- <div class="pl-4 pr-4 pt-4"> -->
      <m-divider />
    <!-- </div> -->

    <div class="pa-4">
      <EntryBtn
        v-for="(entry, index) in entries"
        :key="index"
        :hasIcon="false"
        :label="entry.name"
        @click="onClick(entry)"
      ></EntryBtn>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/Layout/web/PageLayout.vue';
import PageHeader from 'common/components/Layout/web/PageHeader.vue';
import EntryBtn from '@/components/EntryBtn.vue';

export default {
  name: 'Home',
  components: {
    PageLayout,
    PageHeader,
    EntryBtn,
  },
  data() {
    return {
      entries: [
        {
          name: this.$t(`Common.title.business`),
          path: '/rule/business',
        },
        {
          name: this.$t(`Common.title.company`),
          path: '/rule/company',
        },
        {
          name: this.$t(`Common.title.search`),
          path: '/rule/search',
        },
      ],
    };
  },
  methods: {
    onClick(entry) {
      this.$router.push(entry.path);
    },
  },
};
</script>
